import translationConstants from '../../../../constants/ImportExportTranslation.json';

export const dateToString = (utcString: string | null) => {
  const date = utcString ? new Date(utcString).toString() : '';
  const dateString = date.slice(0, 15) || translationConstants.empty_date;
  const timeSting = date.slice(16, 21) || translationConstants.empty_time;

  return `${dateString} | ${timeSting}`;
};
